import ProdutoLib from "@/libs/ProdutoLib.js";

// Métodos adicionais para os temas do cardápio
const CardapioTemasMixin = {
  data() {
    return {
      temaSelecionado: "limpo"
    };
  },
  
  methods: {
    abrirModalImpressao() {
      // Carregar dados da empresa antes de abrir o modal
      this.carregarDadosEmpresa();
      this.$bvModal.show('modal-impressao-cardapio');
    },
    
    async imprimirCardapioComTema() {
      // Fechar o modal
      this.$bvModal.hide('modal-impressao-cardapio');
      
      // Executar impressão com o tema selecionado
      await this.executarImpressao();
    },
    
    async buscarTodosOsProdutos() {
      console.log('Iniciando busca de todos os produtos...');
      
      try {
        // Buscar todos os produtos sem paginação
        const paginacao = {
          page: 1,
          limit: 10000, // Limite alto para pegar todos de uma vez
          filters: {
            grupo: null, // Todos os grupos
            filtro: null // Sem filtro
          }
        };
        
        const resultado = await ProdutoLib.get("", paginacao);
        
        if (resultado && resultado.data) {
          console.log('Produtos encontrados na busca completa:', resultado.data.length);
          return resultado.data;
        }
        
        console.warn('Nenhum produto encontrado na busca completa, usando produtos atuais');
        return this.produtos;
        
      } catch (error) {
        console.error('Erro ao buscar todos os produtos:', error);
        console.warn('Usando produtos atuais como fallback');
        return this.produtos;
      }
    },
    
    async gerarHTMLCardapio() {
      console.log('Iniciando geração do HTML do cardápio...');
      
      // Buscar todos os produtos primeiro
      const todosProdutos = await this.buscarTodosOsProdutos();
      console.log('Total de produtos para o cardápio:', todosProdutos.length);
      
      // Organizar produtos por grupo
      let grupos = await this.organizarProdutosPorGrupo(todosProdutos);
      
      console.log('Grupos após organização:', grupos);
      
      if (!grupos || grupos.length === 0) {
        console.warn('Nenhum grupo encontrado, usando todos os produtos em um grupo único');
        grupos = [{
          nome: 'Todos os Produtos',
          produtos: todosProdutos.slice() // Cópia dos produtos
        }];
      }
      
      // Verificar se todos os produtos estão incluídos
      const totalProdutosNosGrupos = grupos.reduce((total, grupo) => total + grupo.produtos.length, 0);
      console.log('Total de produtos nos grupos:', totalProdutosNosGrupos);
      
      if (totalProdutosNosGrupos !== todosProdutos.length) {
        console.warn(`Alguns produtos podem estar faltando. Esperado: ${todosProdutos.length}, Encontrado: ${totalProdutosNosGrupos}`);
      }
      
      // Gerar HTML baseado no tema selecionado
      if (this.temaSelecionado === 'estilizado') {
        return this.gerarHTMLCardapioEstilizado(grupos);
      } else if (this.temaSelecionado === 'estilizado-claro') {
        return this.gerarHTMLCardapioEstilizadoClaro(grupos);
      } else if (this.temaSelecionado === 'estilizado-branco') {
        return this.gerarHTMLCardapioEstilizadoBranco(grupos);
      } else {
        return this.gerarHTMLCardapioLimpo(grupos);
      }
    },
    
    gerarHTMLCardapioLimpo(grupos) {
      return `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Cardápio - ${this.nomeEmpresa}</title>
          <meta charset="UTF-8">
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 15px;
              color: #333;
              line-height: 1.4;
              background: white;
              font-size: 12px;
            }
            .cabecalho {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 15px 0;
              border-bottom: 2px solid #333;
              margin-bottom: 20px;
            }
            .logo-empresa h1 {
              font-size: 24px;
              font-weight: bold;
              margin: 0;
              color: #333;
            }
            .subtitulo {
              font-size: 14px;
              margin: 3px 0 0 0;
              color: #666;
            }
            .info-empresa {
              text-align: right;
              font-size: 11px;
            }
            .info-empresa p {
              margin: 2px 0;
              color: #666;
            }
            .grupo-categoria {
              margin-bottom: 25px;
              break-inside: avoid;
            }
            .titulo-grupo {
              font-size: 16px;
              font-weight: bold;
              color: #333;
              margin-bottom: 12px;
              padding-bottom: 6px;
              border-bottom: 1px solid #eee;
              text-transform: uppercase;
            }
            .produto-item {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              padding: 8px 0;
              border-bottom: 1px solid #f0f0f0;
              break-inside: avoid;
            }
            .produto-item:last-child {
              border-bottom: none;
            }
            .produto-nome {
              font-size: 13px;
              font-weight: bold;
              margin: 0;
              color: #333;
            }
            .produto-preco {
              font-size: 13px;
              font-weight: bold;
              color: #333;
              min-width: 60px;
              text-align: right;
            }
            .rodape {
              margin-top: 25px;
              padding-top: 15px;
              border-top: 1px solid #eee;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 10px;
              color: #999;
            }
            @media print {
              body { margin: 0; padding: 10px; font-size: 11px; }
              .cabecalho { margin-bottom: 15px; }
              .grupo-categoria { margin-bottom: 20px; }
              .produto-item { padding: 6px 0; }
            }
          </style>
        </head>
        <body>
          <div class="cabecalho">
            <div class="logo-empresa">
              <h1>${this.nomeEmpresa}</h1>
              <p class="subtitulo">Cardápio</p>
            </div>
            <div class="info-empresa">
              ${this.telefoneEmpresa ? `<p>${this.telefoneEmpresa}</p>` : ''}
              ${this.enderecoEmpresa ? `<p>${this.enderecoEmpresa}</p>` : ''}
              ${this.horarioFuncionamento ? `<p>${this.horarioFuncionamento}</p>` : ''}
            </div>
          </div>
          
          <div class="grupos-produtos">
            ${grupos.map(grupo => `
              <div class="grupo-categoria">
                <h2 class="titulo-grupo">${grupo.nome}</h2>
                <div class="produtos-grupo">
                  ${grupo.produtos.map(produto => `
                    <div class="produto-item">
                      <div class="produto-info">
                        <h3 class="produto-nome">${produto.nome}</h3>
                      </div>
                      <div class="produto-preco">
                        R$ ${this.formatarPreco(produto.preco_venda)}
                      </div>
                    </div>
                  `).join('')}
                </div>
              </div>
            `).join('')}
          </div>
          
          <div class="rodape">
            <p>Cardápio impresso em ${new Date().toLocaleDateString('pt-BR')}</p>
            <div>
              <p>Faça seu pedido conosco!</p>
              ${this.whatsappEmpresa ? `<p>WhatsApp: ${this.whatsappEmpresa}</p>` : ''}
            </div>
          </div>
        </body>
        </html>
      `;
    },
    
    gerarHTMLCardapioEstilizado(grupos) {
      const iconesPorCategoria = {
        'pizza': '🍕',
        'bebida': '🥤',
        'sobremesa': '🍰',
        'lanche': '🥪',
        'entrada': '🍤',
        'prato': '🍽️',
        'salada': '🥗',
        'massa': '🍝',
        'carne': '🥩',
        'frango': '🍗',
        'peixe': '🐟',
        'vegano': '🥬',
        'vegetariano': '🥕',
        'especial': '⭐'
      };
      
      const getIconeCategoria = (nomeGrupo) => {
        const nome = nomeGrupo.toLowerCase();
        for (const [categoria, icone] of Object.entries(iconesPorCategoria)) {
          if (nome.includes(categoria)) {
            return icone;
          }
        }
        return '🍽️'; // Ícone padrão
      };
      
      return `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Cardápio - ${this.nomeEmpresa}</title>
          <meta charset="UTF-8">
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap');
            
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: 'Poppins', sans-serif;
              background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
              color: #ffffff;
              line-height: 1.4;
              padding: 15px;
              min-height: 100vh;
              font-size: 12px;
            }
            
            .container {
              max-width: 800px;
              margin: 0 auto;
              background: rgba(0, 0, 0, 0.8);
              border-radius: 15px;
              padding: 20px;
              box-shadow: 0 15px 30px rgba(0, 0, 0, 0.5);
              border: 2px solid #32cd32;
            }
            
            .cabecalho {
              text-align: center;
              margin-bottom: 25px;
              padding-bottom: 20px;
              border-bottom: 2px solid #32cd32;
              position: relative;
              overflow: hidden;
            }
            
            .cabecalho::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(45deg, transparent, rgba(50, 205, 50, 0.1), transparent);
              z-index: 0;
            }
            
            .logo-empresa {
              position: relative;
              z-index: 1;
            }
            
            .logo-empresa h1 {
              font-size: 32px;
              font-weight: 700;
              color: #32cd32;
              text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
              margin-bottom: 8px;
              letter-spacing: 1px;
            }
            
            .subtitulo {
              font-size: 16px;
              color: #ffffff;
              font-weight: 300;
              letter-spacing: 1px;
              margin-bottom: 15px;
            }
            
            .info-empresa {
              display: flex;
              justify-content: center;
              gap: 15px;
              flex-wrap: wrap;
              margin-top: 15px;
            }
            
            .info-empresa p {
              background: rgba(50, 205, 50, 0.2);
              padding: 6px 12px;
              border-radius: 15px;
              font-size: 11px;
              border: 1px solid #32cd32;
            }
            
            .grupo-categoria {
              margin-bottom: 30px;
              background: rgba(255, 255, 255, 0.05);
              border-radius: 12px;
              padding: 18px;
              border: 1px solid rgba(50, 205, 50, 0.3);
              box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
            }
            
            .titulo-grupo {
              font-size: 20px;
              font-weight: 600;
              color: #32cd32;
              margin-bottom: 15px;
              text-align: center;
              text-transform: uppercase;
              letter-spacing: 1px;
              position: relative;
              padding-bottom: 10px;
            }
            
            .titulo-grupo::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 50px;
              height: 2px;
              background: linear-gradient(90deg, transparent, #32cd32, transparent);
            }
            
            .produtos-grupo {
              display: grid;
              gap: 12px;
            }
            
            .produto-item {
              background: rgba(255, 255, 255, 0.08);
              border-radius: 8px;
              padding: 12px;
              border: 1px solid rgba(50, 205, 50, 0.2);
              transition: all 0.3s ease;
              position: relative;
              overflow: hidden;
            }
            
            .produto-item::before {
              content: '';
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(90deg, transparent, rgba(50, 205, 50, 0.1), transparent);
              transition: left 0.5s ease;
            }
            
            .produto-item:hover::before {
              left: 100%;
            }
            
            .produto-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
              z-index: 1;
            }
            
            .produto-nome {
              font-size: 14px;
              font-weight: 500;
              color: #ffffff;
              margin-bottom: 3px;
            }
            
            .produto-preco {
              font-size: 16px;
              font-weight: 700;
              color: #32cd32;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
              min-width: 90px;
              text-align: right;
              background: rgba(50, 205, 50, 0.1);
              padding: 6px 12px;
              border-radius: 20px;
              border: 2px solid #32cd32;
            }
            
            .rodape {
              margin-top: 30px;
              padding-top: 20px;
              border-top: 2px solid #32cd32;
              text-align: center;
              background: rgba(50, 205, 50, 0.1);
              border-radius: 15px;
              padding: 25px;
            }
            
            .rodape p {
              margin: 10px 0;
              text-align: center;
              background: rgba(50, 205, 50, 0.1);
              border-radius: 12px;
              padding: 18px;
            }
            
            .rodape p {
              margin: 8px 0;
              font-size: 13px;
              color: #32cd32;
              font-weight: 500;
            }
            
            .data-impressao {
              font-size: 11px !important;
              color: #999 !important;
              font-weight: 300 !important;
            }
            
            @media print {
              body { 
                background: #1a1a1a !important;
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
                padding: 10px;
                font-size: 11px;
              }
              .container {
                box-shadow: none;
                border: 2px solid #32cd32;
                padding: 15px;
              }
              .cabecalho { margin-bottom: 20px; padding-bottom: 15px; }
              .grupo-categoria { margin-bottom: 25px; padding: 15px; }
              .produto-item { padding: 8px; }
              .titulo-grupo { font-size: 18px; margin-bottom: 12px; }
              .produto-nome { font-size: 12px; }
              .produto-preco { font-size: 14px; min-width: 70px; padding: 4px 8px; }
            }
          </style>
        </head>
        <body style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);">
          <div class="container">
            <div class="cabecalho">
              <div class="logo-empresa">
                <h1>${this.nomeEmpresa}</h1>
              </div>
              <div class="info-empresa">
                ${this.telefoneEmpresa ? `<p>📞 ${this.telefoneEmpresa}</p>` : ''}
                ${this.enderecoEmpresa ? `<p>📍 ${this.enderecoEmpresa}</p>` : ''}
                ${this.horarioFuncionamento ? `<p>🕐 ${this.horarioFuncionamento}</p>` : ''}
              </div>
            </div>
            
            <div class="grupos-produtos">
              ${grupos.map(grupo => `
                <div class="grupo-categoria">
                  <h2 class="titulo-grupo">${getIconeCategoria(grupo.nome)} ${grupo.nome}</h2>
                  <div class="produtos-grupo">
                    ${grupo.produtos.map(produto => `
                      <div class="produto-item">
                        <div class="produto-content">
                          <div class="produto-info">
                            <h3 class="produto-nome">${produto.nome}</h3>
                          </div>
                          <div class="produto-preco">
                            R$ ${this.formatarPreco(produto.preco_venda)}
                          </div>
                        </div>
                      </div>
                    `).join('')}
                  </div>
                </div>
              `).join('')}
            </div>
            
            <div class="rodape">
              <p class="data-impressao">Cardápio impresso em ${new Date().toLocaleDateString('pt-BR')}</p>

              ${this.whatsappEmpresa ? `<p>📱 WhatsApp: ${this.whatsappEmpresa}</p>` : ''}
            </div>
          </div>
        </body>
        </html>
      `;
    },

    gerarHTMLCardapioEstilizadoClaro(grupos) {
      const iconesPorCategoria = {
        'pizza': '🍕',
        'bebida': '🥤',
        'sobremesa': '🍰',
        'lanche': '🥪',
        'entrada': '🍤',
        'prato': '🍽️',
        'salada': '🥗',
        'massa': '🍝',
        'carne': '🥩',
        'frango': '🍗',
        'peixe': '🐟',
        'vegano': '🥬',
        'vegetariano': '🥕',
        'especial': '⭐'
      };
      
      const getIconeCategoria = (nomeGrupo) => {
        const nome = nomeGrupo.toLowerCase();
        for (const [categoria, icone] of Object.entries(iconesPorCategoria)) {
          if (nome.includes(categoria)) {
            return icone;
          }
        }
        return '🍽️'; // Ícone padrão
      };
      
      return `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Cardápio - ${this.nomeEmpresa}</title>
          <meta charset="UTF-8">
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap');
            
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: 'Poppins', sans-serif;
              background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
              color: #2d3748;
              line-height: 1.4;
              padding: 15px;
              min-height: 100vh;
              font-size: 12px;
            }
            
            .container {
              max-width: 800px;
              margin: 0 auto;
              background: #ffffff;
              border-radius: 15px;
              padding: 20px;
              box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
              border: 2px solid #38a169;
            }
            
            .cabecalho {
              text-align: center;
              margin-bottom: 25px;
              padding-bottom: 20px;
              border-bottom: 2px solid #38a169;
              position: relative;
              overflow: hidden;
            }
            
            .cabecalho::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(45deg, transparent, rgba(56, 161, 105, 0.1), transparent);
              z-index: 0;
            }
            
            .logo-empresa {
              position: relative;
              z-index: 1;
            }
            
            .logo-empresa h1 {
              font-size: 32px;
              font-weight: 700;
              color: #38a169;
              text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
              margin-bottom: 8px;
              letter-spacing: 1px;
            }
            
            .subtitulo {
              font-size: 16px;
              color: #4a5568;
              font-weight: 300;
              letter-spacing: 1px;
              margin-bottom: 15px;
            }
            
            .info-empresa {
              display: flex;
              justify-content: center;
              gap: 15px;
              flex-wrap: wrap;
              margin-top: 15px;
            }
            
            .info-empresa p {
              background: rgba(56, 161, 105, 0.1);
              padding: 6px 12px;
              border-radius: 15px;
              font-size: 11px;
              border: 1px solid #38a169;
              color: #2d3748;
            }
            
            .grupo-categoria {
              margin-bottom: 30px;
              background: #f7fafc;
              border-radius: 12px;
              padding: 18px;
              border: 1px solid rgba(56, 161, 105, 0.2);
              box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
            }
            
            .titulo-grupo {
              font-size: 20px;
              font-weight: 600;
              color: #38a169;
              margin-bottom: 15px;
              text-align: center;
              text-transform: uppercase;
              letter-spacing: 1px;
              position: relative;
              padding-bottom: 10px;
            }
            
            .titulo-grupo::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 50px;
              height: 2px;
              background: linear-gradient(90deg, transparent, #38a169, transparent);
            }
            
            .produtos-grupo {
              display: grid;
              gap: 12px;
            }
            
            .produto-item {
              background: #ffffff;
              border-radius: 8px;
              padding: 12px;
              border: 1px solid rgba(56, 161, 105, 0.2);
              transition: all 0.3s ease;
              position: relative;
              overflow: hidden;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
            }
            
            .produto-item::before {
              content: '';
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(90deg, transparent, rgba(56, 161, 105, 0.1), transparent);
              transition: left 0.5s ease;
            }
            
            .produto-item:hover::before {
              left: 100%;
            }
            
            .produto-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
              z-index: 1;
            }
            
            .produto-nome {
              font-size: 14px;
              font-weight: 500;
              color: #2d3748;
              margin-bottom: 3px;
            }
            
            .produto-preco {
              font-size: 16px;
              font-weight: 700;
              color: #38a169;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
              min-width: 90px;
              text-align: right;
              background: rgba(56, 161, 105, 0.1);
              padding: 6px 12px;
              border-radius: 20px;
              border: 2px solid #38a169;
            }
            
            .rodape {
              margin-top: 30px;
              padding-top: 20px;
              border-top: 2px solid #38a169;
              text-align: center;
              background: rgba(56, 161, 105, 0.05);
              border-radius: 15px;
              padding: 25px;
            }
            
            .rodape p {
              margin: 8px 0;
              font-size: 13px;
              color: #38a169;
              font-weight: 500;
            }
            
            .data-impressao {
              font-size: 11px !important;
              color: #718096 !important;
              font-weight: 300 !important;
            }
            
            @media print {
              body { 
                background: #ffffff !important;
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
                padding: 10px;
                font-size: 11px;
              }
              .container {
                box-shadow: none;
                border: 2px solid #38a169;
                padding: 15px;
              }
              .cabecalho { margin-bottom: 20px; padding-bottom: 15px; }
              .grupo-categoria { margin-bottom: 25px; padding: 15px; }
              .produto-item { padding: 8px; }
              .titulo-grupo { font-size: 18px; margin-bottom: 12px; }
              .produto-nome { font-size: 12px; }
              .produto-preco { font-size: 14px; min-width: 70px; padding: 4px 8px; }
            }
          </style>
        </head>
        <body style="background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);">
          <div class="container">
            <div class="cabecalho">
              <div class="logo-empresa">
                <h1>${this.nomeEmpresa}</h1>
              </div>
              <div class="info-empresa">
                ${this.telefoneEmpresa ? `<p>📞 ${this.telefoneEmpresa}</p>` : ''}
                ${this.enderecoEmpresa ? `<p>📍 ${this.enderecoEmpresa}</p>` : ''}
                ${this.horarioFuncionamento ? `<p>🕐 ${this.horarioFuncionamento}</p>` : ''}
              </div>
            </div>
            
            <div class="grupos-produtos">
              ${grupos.map(grupo => `
                <div class="grupo-categoria">
                  <h2 class="titulo-grupo">${getIconeCategoria(grupo.nome)} ${grupo.nome}</h2>
                  <div class="produtos-grupo">
                    ${grupo.produtos.map(produto => `
                      <div class="produto-item">
                        <div class="produto-content">
                          <div class="produto-info">
                            <h3 class="produto-nome">${produto.nome}</h3>
                          </div>
                          <div class="produto-preco">
                            R$ ${this.formatarPreco(produto.preco_venda)}
                          </div>
                        </div>
                      </div>
                    `).join('')}
                  </div>
                </div>
              `).join('')}
            </div>
            
            <div class="rodape">
              <p class="data-impressao">Cardápio impresso em ${new Date().toLocaleDateString('pt-BR')}</p>
              <p>🍽️ Faça seu pedido conosco! 🍽️</p>
              ${this.whatsappEmpresa ? `<p>📱 WhatsApp: ${this.whatsappEmpresa}</p>` : ''}
            </div>
          </div>
        </body>
        </html>
      `;
    },

    gerarHTMLCardapioEstilizadoBranco(grupos) {
      const iconesPorCategoria = {
        'pizza': '🍕',
        'bebida': '🥤',
        'sobremesa': '🍰',
        'lanche': '🥪',
        'entrada': '🍤',
        'prato': '🍽️',
        'salada': '🥗',
        'massa': '🍝',
        'carne': '🥩',
        'frango': '🍗',
        'peixe': '🐟',
        'vegano': '🥬',
        'vegetariano': '🥕',
        'especial': '⭐'
      };
      
      const getIconeCategoria = (nomeGrupo) => {
        const nome = nomeGrupo.toLowerCase();
        for (const [categoria, icone] of Object.entries(iconesPorCategoria)) {
          if (nome.includes(categoria)) {
            return icone;
          }
        }
        return '🍽️'; // Ícone padrão
      };
      
      return `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Cardápio - ${this.nomeEmpresa}</title>
          <meta charset="UTF-8">
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
            
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: 'Inter', sans-serif;
              background: #ffffff;
              color: #1a202c;
              line-height: 1.4;
              padding: 20px;
              min-height: 100vh;
              font-size: 12px;
            }
            
            .container {
              max-width: 850px;
              margin: 0 auto;
              background: #ffffff;
              border-radius: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            
            .cabecalho {
              text-align: center;
              margin-bottom: 30px;
              padding-bottom: 20px;
              border-bottom: 1px solid #e2e8f0;
            }
            
            .logo-empresa h1 {
              font-size: 36px;
              font-weight: 700;
              color: #2d3748;
              margin-bottom: 8px;
              letter-spacing: -0.5px;
            }
            
            .subtitulo {
              font-size: 14px;
              color: #718096;
              font-weight: 400;
              letter-spacing: 0.5px;
              margin-bottom: 20px;
              text-transform: uppercase;
            }
            
            .info-empresa {
              display: flex;
              justify-content: center;
              gap: 20px;
              flex-wrap: wrap;
              margin-top: 20px;
            }
            
            .info-empresa p {
              background: #f7fafc;
              padding: 8px 16px;
              border-radius: 4px;
              font-size: 11px;
              color: #4a5568;
              border: 1px solid #e2e8f0;
            }
            
            .grupo-categoria {
              margin-bottom: 35px;
              break-inside: avoid;
            }
            
            .titulo-grupo {
              font-size: 22px;
              font-weight: 600;
              color: #2d3748;
              margin-bottom: 18px;
              text-align: left;
              letter-spacing: -0.3px;
              position: relative;
              padding-left: 8px;
            }
            
            .titulo-grupo::before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              width: 3px;
              background: #4299e1;
              border-radius: 2px;
            }
            
            .produtos-grupo {
              display: grid;
              gap: 1px;
              background: #e2e8f0;
              border-radius: 4px;
              overflow: hidden;
            }
            
            .produto-item {
              background: #ffffff;
              padding: 16px;
              border: none;
              transition: all 0.2s ease;
              position: relative;
            }
            
            .produto-item:hover {
              background: #f7fafc;
            }
            
            .produto-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            
            .produto-nome {
              font-size: 15px;
              font-weight: 500;
              color: #2d3748;
              margin: 0;
            }
            
            .produto-preco {
              font-size: 15px;
              font-weight: 600;
              color: #4299e1;
              min-width: 80px;
              text-align: right;
            }
            
            .rodape {
              margin-top: 40px;
              padding-top: 20px;
              border-top: 1px solid #e2e8f0;
              text-align: center;
            }
            
            .rodape p {
              margin: 8px 0;
              font-size: 12px;
              color: #4a5568;
              font-weight: 400;
            }
            
            .data-impressao {
              font-size: 10px !important;
              color: #a0aec0 !important;
              font-weight: 300 !important;
            }
            
            @media print {
              body { 
                background: #ffffff !important;
                padding: 15px;
                font-size: 11px;
              }
              .container { padding: 0; }
              .cabecalho { margin-bottom: 25px; padding-bottom: 15px; }
              .grupo-categoria { margin-bottom: 30px; }
              .produto-item { padding: 12px; }
              .titulo-grupo { font-size: 20px; margin-bottom: 15px; }
              .produto-nome { font-size: 13px; }
              .produto-preco { font-size: 13px; min-width: 70px; }
              .rodape { margin-top: 35px; padding-top: 15px; }
            }
          </style>
        </head>
        <body style="background: #ffffff;">
          <div class="container">
            <div class="cabecalho">
              <div class="logo-empresa">
                <h1>${this.nomeEmpresa}</h1>
                <p class="subtitulo">Cardápio</p>
              </div>
              <div class="info-empresa">
                ${this.telefoneEmpresa ? `<p>📞 ${this.telefoneEmpresa}</p>` : ''}
                ${this.enderecoEmpresa ? `<p>📍 ${this.enderecoEmpresa}</p>` : ''}
                ${this.horarioFuncionamento ? `<p>🕐 ${this.horarioFuncionamento}</p>` : ''}
              </div>
            </div>
            
            <div class="grupos-produtos">
              ${grupos.map(grupo => `
                <div class="grupo-categoria">
                  <h2 class="titulo-grupo">${getIconeCategoria(grupo.nome)} ${grupo.nome}</h2>
                  <div class="produtos-grupo">
                    ${grupo.produtos.map(produto => `
                      <div class="produto-item">
                        <div class="produto-content">
                          <div class="produto-info">
                            <h3 class="produto-nome">${produto.nome}</h3>
                          </div>
                          <div class="produto-preco">
                            R$ ${this.formatarPreco(produto.preco_venda)}
                          </div>
                        </div>
                      </div>
                    `).join('')}
                  </div>
                </div>
              `).join('')}
            </div>
            
            <div class="rodape">
              <p class="data-impressao">Cardápio impresso em ${new Date().toLocaleDateString('pt-BR')}</p>
              <p>Faça seu pedido conosco!</p>
              ${this.whatsappEmpresa ? `<p>📱 WhatsApp: ${this.whatsappEmpresa}</p>` : ''}
            </div>
          </div>
        </body>
        </html>
      `;
    }
  }
};

export default CardapioTemasMixin;
